import landscapeCarousel from 'components/landscapeCarousel';
import hubPromotionTpl from 'templates/carousels/__carouselHubPromotion.tpl';
import { SwiperCarouselPortraitBreakpoints } from 'components/settings/BreakpointSettings';

export default function hubPromotionCarousel($wrapper, carouselData) {
    let $carouselElement = $wrapper.find('.js-video-carousel');

    try {
        const hubPromotionCarousel = {
            wrapper: $carouselElement,
            init: function () {
                let options = {
                    endPoint: carouselData.baseEndpoint,
                    template: hubPromotionTpl,
                    responsive: SwiperCarouselPortraitBreakpoints,
                };

                landscapeCarousel({
                    parentContainer: $carouselElement,
                    options: options,
                });

                //$wrapper.on('init', () => hubPromotionWrapperInit());
            },
        };

        return hubPromotionCarousel;
    } catch (e) {
        console.log(e);
    }

    function hubPromotionWrapperInit() {}
}
